import {
  Box,
  FormLabel,
  Skeleton,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import LearningPlanCourseList from 'components/learningPlan/LearningPlanCourseList';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLearningPlanCoursesAction } from 'store/modules/learningPlanCourse/learningPlanCourse-action';
import { ReducerStatus } from 'utils/constants';
import { v4 as uuidv4 } from 'uuid';

function ClassCoursesPreview() {
  const { values } = useFormikContext();
  const dispatch = useDispatch();

  const [currentValue, setCurrentValue] = useState(null);

  const learningPlanCourses = useSelector(
    (state) => state.learningPlanCourse.learningPlanCourses
  );
  const getLearningPlanCourses = useSelector(
    (state) => state.learningPlanCourse.getLearningPlanCourses
  );

  const scrollbarTheme = useColorModeValue('scrollbar-light', 'scrollbar-dark');

  useEffect(() => {
    setCurrentValue(values?.learningPlan?.value);
    if (values.learningPlan?.value)
      if (values.learningPlan.value !== currentValue) {
        dispatch(getLearningPlanCoursesAction(values.learningPlan.value));
      }
  }, [values, currentValue, dispatch]);

  return (
    values?.learningPlan && (
      <>
        <FormLabel>Courses: ({learningPlanCourses.length})</FormLabel>
        <Box className={scrollbarTheme} overflowY="scroll" h={350} w="100%">
          {getLearningPlanCourses.status === ReducerStatus.LOADING ? (
            <Stack gap={4}>
              {[...Array(5)].map(() => (
                <Skeleton
                  key={uuidv4()}
                  w="100%"
                  height="65px"
                  borderRadius="md"
                />
              ))}
            </Stack>
          ) : (
            <LearningPlanCourseList
              learningPlanCourses={learningPlanCourses}
              isPreviewMode
            />
          )}
        </Box>
      </>
    )
  );
}

export default ClassCoursesPreview;
